import { SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
export const TyreLabelStyle = styled.section `
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > a {
    align-self: flex-start;
  }

  .disclaimer {
    background: ${SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT};
    padding: 1rem;
    display: flex;
    gap: 1rem;

    svg {
      min-width: fit-content;
    }
  }
`;
export const ListStyle = styled.ul `
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  list-style-type: none;
  padding-left: 0;
`;
export const ListItemStyle = styled.li `
  figure {
    display: flex;
    flex-direction: column;
    gap: 16px;

    img {
      height: 20rem;
      object-fit: scale-down;
    }

    & > a {
      align-self: flex-start;
    }
  }
`;
